import { v4 as uuidv4 } from 'uuid';
import { Installation} from '../domain/Installation';
import { InstallationsRepository,  } from '../domain/InstallationsRepository';
import { ServiceDeliveryRepository } from "../domain/ServiceDeliveryRepository";

export class NewInstallationCommand {
    constructor(
        private readonly repo_installation: InstallationsRepository,
        private readonly file_repo,
        private readonly screen_data,
        private readonly sd_repo: ServiceDeliveryRepository,
    ) {
    }

    async execute(user_id: number) {
        const uuid = uuidv4();
        let ins = await this.repo_installation.find_by_user_id(user_id)
        let sds = await this.sd_repo.find_by_user_id(user_id)
        let sd_id = 0;
        for (let sd of sds) {
            if (sd.status) {
                sd_id = sd.sd_id;
                if (sd.contract_type === 'Premium' || sd.contract_type === 'Enterprise' && !ins.some(item => item.sd_id === sd.sd_id)) {
                    this.screen_data.payment_popup.show_file_field = false;
                    break;
                } else {
                    this.screen_data.payment_popup.show_file_field = true;
                }
            }
        }
        let file = await this.screen_data.payment_popup.show();
        if (file != 'close' && this.screen_data.payment_popup.show_file_field && file) {
            let installation = new Installation(uuid, user_id, sd_id)
            let path = await this.file_repo.uploadFile(file);
            await this.repo_installation.create(installation, path)
        } else if (!this.screen_data.payment_popup.show_file_field && file != 'close') {
            let installation = new Installation(uuid, user_id, sd_id)
            await this.repo_installation.create(installation, '')
        }
    }
}